import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const GhatMap = ({ locations }) => {
  const { t } = useTranslation();
  
  return (
    <Box sx={{ height: '100%', width: '100%', p: 2, bgcolor: 'background.paper' }}>
      <Typography variant="h6" gutterBottom>
        {t('Map view coming soon')}
      </Typography>
      <Typography>
        {t('We are working on an interactive map to help you explore all the sacred ghats of Ayodhya.')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {t('In the meantime, you can browse the list view to discover the ghats.')}
      </Typography>
      
      {/* Placeholder for future map implementation */}
      <Box 
        sx={{ 
          mt: 4, 
          height: 'calc(100% - 150px)', 
          minHeight: '400px',
          bgcolor: 'action.hover',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h5" color="text.secondary">
          {t('Interactive Map')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('Coming Soon')}
        </Typography>
      </Box>
    </Box>
  );
};

export default GhatMap;
